export const RaTopToolbarStyles = {
    styleOverrides: {
        root: {
            gap: '16px !important',
        },
    },
};
